import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatReference' })
export class FormatReferencePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace('VC', '');
  }
}
